import { render, staticRenderFns } from "./AdditionalOptionsButton.vue?vue&type=template&id=fee89bf8&scoped=true"
import script from "./AdditionalOptionsButton.vue?vue&type=script&lang=js"
export * from "./AdditionalOptionsButton.vue?vue&type=script&lang=js"
import style0 from "./AdditionalOptionsButton.vue?vue&type=style&index=0&id=fee89bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee89bf8",
  null
  
)

export default component.exports